/**
 * 销售数据概览数据管理
 */
import api from '../../api/api'
import * as types from '../mutation'
import { getNowTime } from '../../utils/com'

const state = {
    pressdata: {},
    presstotal: 0,
    // newContent: {},
    // productSales: {}
}

const getters = {
    pressdata: state => state.pressdata,
    presstotal: state => state.presstotal,
    // newContent: state => state.newContent,
    // productSales: state => state.productSales
}

 const actions = {
    /**
     * 获取销售数据概览数据
     */
    // getPressData ({ commit, state, rootState }, param) {
    //     // loading 开始
    //     // commit(types.COM_LOADING_STATUS,true)
    //     console.debug("getPressData> param:%o", param);
    //     commit(types.CLEAR_PRESS_LIST)
    //     api.apiCommunication('/api/press/list', param, function (response) {
    //         console.debug("getPressData /api/press/list> response:%o", response);
    //         // console.log(response);
    //         // 获取成功，提交mutations处理数据
    //         commit(types.GET_PRESS_LIST_SUCCESS, { response })
    //         // loading 结束
    //         // commit(types.COMM_LOADING_STATUS,false)
    //     })
    // },


    getPressData ({ commit, state, rootState }, param) {
        console.debug("getPressData> param:%o", param);
        commit(types.GET_PRESS_LIST_SUCCESS, {})

        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/press/list',
            param,
            (response) => {
                console.debug("getPressData ok response:%o", response);
                commit(types.GET_PRESS_LIST_SUCCESS, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getPressData err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });

    },

    searchPressData ({ commit, state, rootState }, param) {
        console.debug("searchPressData> param:%o", param);
        commit(types.GET_PRESS_LIST_SUCCESS, {})

        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/press/search',
            param,
            (response) => {
                console.debug("searchPressData ok response:%o", response);
                commit(types.GET_PRESS_LIST_SUCCESS, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("searchPressData err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });

    },

   //  /**
   //   * 获取订单列表
   //   */
   //  addNewsContent ({ commit }, param) {
   //      console.debug("addNewsContent> param:%o", param);
   //      // api.apiCommunication('/news/add', param, function (response) {
   //      //     console.debug("api /news/add> response:%o, param:%o", response, param);
   //      //     commit(types.ADD_NEWS_CONTENT, { response, param })
   //      // })

   //      return new Promise((resolve, reject) => {
   //        api.apiCommunication(
   //          '/api/news/add',
   //          param,
   //          (response) => {
   //              /*console.debug("reqWaitressMonitor ok:%o", sHostMon);*/
   //              commit(types.ADD_NEWS_CONTENT, { response, param })
   //              resolve(response)
   //          },
   //          (err) => {
   //              /*console.debug("reqWaitressMonitor fail:%o", sHostErrMsg);*/
   //              // commit(types.ADD_NEWS_CONTENT, { err, param });
   //              reject(err)
   //          }
   //        )
   //      });

   //  },

   //  editNewsContent ({ commit }, param) {
   //      console.debug("editNewsContent> param:%o", param);
   //      return new Promise((resolve, reject) => {
   //        api.apiCommunication(
   //          '/api/news/edit',
   //          param,
   //          (resp) => {
   //              console.debug("editNewsContent resp:%o", resp);
   //              let response = {};
   //              response.data = param.id;
   //              response.code = resp.code;
   //              commit(types.ADD_NEWS_CONTENT, { response, param })
   //              resolve(resp)
   //          },
   //          (err) => {
   //              /*console.debug("reqWaitressMonitor fail:%o", sHostErrMsg);*/
   //              reject(err)
   //          }
   //        )
   //      });

   //  },

   // updateNewsContent ({ commit }, param) {
   //      console.debug("updateNewsContent> param:%o", param);
   //      // api.apiCommunication('/news/add', param, function (response) {
   //      //     console.debug("api /news/add> response:%o, param:%o", response, param);
   //      //     commit(types.ADD_NEWS_CONTENT, { response, param })
   //      // })
   //      let response = {};
   //      response.data = param.id;
   //      response.code = 0;
   //      commit(types.ADD_NEWS_CONTENT, { response, param })
   //  },

   //  transferNewsState ({ commit }, param) {
   //      console.debug("transferNewsState> param:%o", param);
   //      return new Promise((resolve, reject) => {
   //        api.apiCommunication(
   //          '/api/news/transfer',
   //          param,
   //          (resp) => {
   //              console.debug("transferNewsState resp:%o", resp);
   //              resolve(resp)
   //          },
   //          (err) => {
   //              /*console.debug("reqWaitressMonitor fail:%o", sHostErrMsg);*/
   //              reject(err)
   //          }
   //        )
   //      });

   //  },



    /**
     * 获取商品销售统计
     */
    // getProductSales ({ commit }, param) {
    //     api.apiCommunication('/Order/ProductSalesData', param, function (response) {
    //         commit(types.GET_PRODUCTSALESDATA_SUCCESS, { response })
    //     })
    // }
}

const mutations = {
    [types.GET_PRESS_LIST_SUCCESS] (state, { response }) {
        let _data = {}
        if(response && response.code === 0){
          _data = response.data.news
          state.presstotal = Number(response.data.total)
        }
        state.pressdata = _data
        // _data.maintainProportions = Number(_data.maintainProportions)
    },
    // [types.ADD_NEWS_CONTENT] (state, { response, param }) {
    //     console.debug("ADD_NEWS_CONTENT> response:%o, param:%o", response, param);
    //     let _data = {}
    //     if(response.code === 0){
    //         _data = param
    //         _data.id = response.data
    //         _data.created = getNowTime()
    //     }
    //     state.newContent = _data
    // },
    // [types.GET_PRODUCTSALESDATA_SUCCESS] (state, { response }) {
    //     if(response.status === '404') {
    //         state.productSales = {
    //             ProductList: [],
    //             count: 0
    //         }
    //         return false
    //     }
    //     let _data = response.data
    //     _data.count = Number(response.data.count)
    //     state.productSales =_data
    // },
}

export default{
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/press.js